import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { buscarDesvio, incluirDesvio, alterarDesvio, excluirDesvio  } from '../../services/apigateway';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';
import ModalSenha from '../../components/Modal/modalsenha';

export default function CadastroDesvios({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);

  const { codigo } = useParams();
  const history = useNavigate();

  const readOnly = (funcao === 'Consulta' || funcao === 'Exclusão');

  const[descricao, setDescricao] = useState('');
  const[situacao, setSituacao] = useState('A');
  const[loading, setLoading] = useState(false);

  const [mostrarModal, setMostrarModal] = useState(false);

  useEffect(()=>{
    async function loadDesvio(){
      setLoading(true);

      try {
        const result = await buscarDesvio(clienteId, codigo);
        preencheSelecionado(result);

      } catch (err) {
        // console.log(`Retornou o seguinte erro: ${err}`);
        setLoading(false);
        toast.error('Erro ao buscar desvio');
      }
  
      setLoading(false);
    }

    if (funcao !== 'Inclusão' && funcao !== 'Consulta' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModal(true);
      return;
    }

    if (funcao !== 'Inclusão'){
      loadDesvio();
    }
  }, []);

  function preencheSelecionado(response) {
    setDescricao(response[0].des_desvio);
    setSituacao(response[0].sit_desvio);
  }

  function autorizado() {
    // setAutorizado(true);
    // console.log("Autorizado");
    setMostrarModal(false);
  }

  function naoAutorizado() {
    setMostrarModal(false);
    history('/desvios');
  }

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Consulta') {
      history('/desvios');
    }

    if (funcao === 'Alteração' || funcao === 'Inclusão') {
      if (descricao === '' || situacao === '') {
        toast.error('Informe todos os campos obrigatórios');
        return;
      }
    }

    if (funcao === 'Inclusão') {
      //INSERT
      try {
        const response = await incluirDesvio(clienteId, { descricao: descricao, situacao: situacao });

        if (response === 200) {
          toast.success('Desvio incluído com sucesso!!');
          history('/desvios');

        } else {
            toast.error('Erro na inclusão do desvio (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na inclusão do desvio - Retorno');
      }
    }

    if (funcao === 'Alteração') {
      //UPDATE
      try {
        const response = await alterarDesvio(clienteId, { codigo: codigo, descricao: descricao, situacao: situacao });

        if (response === 200) {
          toast.success('Desvio alterado com sucesso!!');
          history('/desvios');

        } else {
            toast.error('Erro na alteração do desvio (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na alteração do desvio - Retorno');
      }
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        const response = await excluirDesvio(clienteId, codigo);

        if (response === 200) {
          toast.success('Desvio excluído com sucesso!!');
          history('/desvios');

        } else {
            toast.error('Erro na exclusão do desvio (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na exclusão do desvio - Retorno');
      }
    }

    return;
  }

  function handleSair(e){
    history('/desvios');
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Desvio'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Desvio...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (mostrarModal) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Desvios ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>
            <form method='POST' id='form-geral' className='form-geral'>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Informações do Desvio</h3>
              <div className="row grid md:grid-cols-1 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Descrição</label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='descricao' 
                      name='descricao' 
                      placeholder={'Digite a descrição do desvio'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='descricao' 
                      value={descricao} 
                      onChange={(e) => setDescricao(e.target.value)}
                      required 
                      readOnly={(funcao === 'Consulta' || funcao === 'Exclusão')}
                    />
                  </div>
                </div> 
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'>Situação</h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ativo' 
                        name='ativar' 
                        value='A' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'A'}
                        disabled={readOnly}
                      /> 
                      <label className='mb-0'>Ativo</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='inativo' 
                        name='ativar' 
                        value='I' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'I'}
                        disabled={readOnly}
                      /> 
                      <label>Inativo</label>
                    </div>
                  </div>
                </div>
              </div>

              <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
            </form>
          </section>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
